import { useSelector } from 'react-redux';
import { prepareNexset } from 'new/hooks/adapters/useMyNexsets';
import { Nexset } from 'new/entities/Nexset';
import { useMemo } from 'react';

export function useNexset(id): Nexset {
  const entities = useSelector((state: any) => state.entities);
  const dataSets = useSelector((state: any) => state.dataSets);
  const paging = useSelector((state: any) => state.paging);
  const { dataSets: nexsets } = entities;
  const nexset = nexsets[id] || {};
  return useMemo(() => {
    if (!id) {
      return null;
    }
    return prepareNexset(nexset, { entities, dataSets, paging });
  }, [
    nexset,
    dataSets,
    entities.users,
    entities.dataSets,
    entities.vendors,
    entities.sources,
    entities.sinks,
    entities.docs,
  ]);
}
